export default __webpack_public_path__ + "media/projects/red1-thumb-fe7d8e55.svg";